/**
 * 需求来源：docs/旅游落地页/AI提示词.md 第1次提交 需求2 + 第2次补充（任务单 DEV-120352）。
 * 注意事项：
 * 1. 原型 30 张图片原为 CJEC 站点远程外链，已下载、转码为 progressive JPEG（单张 ≤150KB）。
 * 2. **第2次补充**：图片改为编号命名 cjBusinessTravel01~30，并从 app/web/asset 迁至
 *    公共资源仓 `static-resource-platform/resources/egg/cjBusinessTravel/`，随该仓发布到测试/线上。
 *    因此不再走 webpack 的 `asset` 别名 require，改为按 cdnHost 拼 CDN 路径 —— 与 /odm、/alternatives
 *    同款（见 app/web/page/alternatives/constants.js 的 `${cdnHost}/resources/egg/alternatives/${name}`）。
 * 3. 编号按**页面渲染顺序**分配（Hero → About → Experiences → City Explorer 各城 → 仅 CSS 用的背景图），
 *    同一张图多处复用时以首次出现为准；对照见下方清单，改图时按用途定位、不必回溯原型文件名。
 * 4. cdnHost 由 fetch.js 从 config.view.variable.CDN_HOST 取得并经 pageData 下传；
 *    本地开发下 cdnHost 为空串，路径退化为同源 `/resources/egg/...`。
 */
'use strict';

var DIR = '/resources/egg/cjBusinessTravel/';

/**
 * 编号 → 用途对照（便于改图时定位，值即文件名后缀编号）。
 * 第15次补充：本表此前只写到 30，未随第11次补充的城市专属图（31~66）更新，已按现状补齐到 69。
 * 「未使用」= 实体仍在资源仓、页面已不引用；实体一律保留，因为「编号 01..N 连续无缺号」既是
 * CASE-A2b 的判据，也是后续新增图「序号顺延」取号的前提，删号会让顺延规则失去依据。
 */
var USAGE = {
  '01': 'Hero 左列-Guangzhou / CTA 背景',
  '02': 'Hero 左列-Shenzhen',
  '03': '（未使用）原 Hero 左列-Chengdu，第15次补充需求6 起改用 68',
  '04': 'Hero 左列-Chongqing',
  '05': '（未使用）原 Hero 右列-Xi’an，第15次补充需求6 起改用 67',
  '06': 'Hero 右列-Hangzhou',
  '07': 'Hero 右列-Shanghai',
  '08': 'Hero 右列-Beijing',
  '09': 'Hero 右列-Zhangjiajie',
  '10': 'About 主图',
  '11': 'About 小图',
  '12': 'Experiences-Historic China',
  '13': '（未使用）原 Experiences-Modern China，第15次补充需求6 起改用 69',
  '14': '（未使用）原 Experiences-Chinese Food，第16次补充需求1 起改用 76',
  '15': 'Experiences-Local Lifestyle',
  '16': 'Guangzhou 图库 1', '17': 'Guangzhou 图库 2', '18': 'Guangzhou 图库 3',
  '19': 'Guangzhou 图库 4', '20': 'Guangzhou 图库 5', '21': 'Guangzhou 图库 6',
  '22': 'Shenzhen 图库 1', '23': 'Shenzhen 图库 2', '24': 'Shenzhen 图库 3',
  '25': 'Shenzhen 图库 4', '26': 'Shenzhen 图库 5', '27': 'Shenzhen 图库 6',
  '28': '（未使用）原多城图库共用图，第11次补充改专属图后闲置',
  '29': '（未使用）原多城图库共用图，第11次补充改专属图后闲置',
  '30': 'Hero 区块 CSS 背景大图（仅 index.less 使用）',
  '31': 'Hangzhou 图库 1', '32': 'Hangzhou 图库 2', '33': 'Hangzhou 图库 3',
  '34': 'Hangzhou 图库 4', '35': 'Hangzhou 图库 5', '36': 'Hangzhou 图库 6',
  '37': 'Shanghai 图库 1', '38': 'Shanghai 图库 2', '39': 'Shanghai 图库 3',
  '40': 'Shanghai 图库 4', '41': 'Shanghai 图库 5', '42': 'Shanghai 图库 6',
  '43': '（未使用）原 Beijing 图库 1，第15次补充需求4 删除该城后闲置，实体保留占号',
  '44': '（未使用）原 Beijing 图库 2，同上', '45': '（未使用）原 Beijing 图库 3，同上',
  '46': '（未使用）原 Beijing 图库 4，同上', '47': '（未使用）原 Beijing 图库 5，同上',
  '48': '（未使用）原 Beijing 图库 6，同上',
  '49': 'Xi’an 图库 1', '50': 'Xi’an 图库 2', '51': 'Xi’an 图库 3',
  '52': 'Xi’an 图库 4', '53': 'Xi’an 图库 5', '54': 'Xi’an 图库 6',
  '55': 'Chengdu 图库 1', '56': 'Chengdu 图库 2', '57': 'Chengdu 图库 3',
  '58': 'Chengdu 图库 4', '59': 'Chengdu 图库 5', '60': 'Chengdu 图库 6',
  '61': 'Zhangjiajie 图库 1', '62': 'Zhangjiajie 图库 2', '63': 'Zhangjiajie 图库 3',
  '64': 'Zhangjiajie 图库 4', '65': 'Zhangjiajie 图库 5', '66': 'Zhangjiajie 图库 6',
  '67': 'Hero 右列-Xi’an（第15次补充需求6 新增，兵马俑，替代 05）',
  '68': 'Hero 左列-Chengdu（第15次补充需求6 新增，大熊猫，替代 03）',
  '69': 'Experiences-Modern China（第15次补充需求6 新增，杭州钱江新城夜景，替代 13）',
  // 第16次补充：资源仓新增 70~76（开发已发布测试环境）。70~75 是新城 Chongqing 的图库专属图，
  // 按业务方「按照顺序引用」的要求与图库第 1~6 张一一对应；76 替换 Experiences「Chinese Food」主图。
  '70': 'Chongqing 图库 1', '71': 'Chongqing 图库 2', '72': 'Chongqing 图库 3',
  '73': 'Chongqing 图库 4', '74': 'Chongqing 图库 5', '75': 'Chongqing 图库 6',
  '76': 'Experiences-Chinese Food（第16次补充需求1 新增，替代 14）',
  // DEV-126262：中国城市竖版视频模块的 5 张封面图，序号顺延 77~81，与卡片顺序一一对应。
  // 原始来源是 https://img.youtube.com/vi/<videoId>/hqdefault.jpg，按需求「图片下载到本地、
  // 上传 OSS 后再使用」落到本仓既有的公共资源仓取址方式；**实体待业务方上传资源仓/OSS**，
  // 未上传前页面这 5 张会裂图（单测 CASE-A2b/CASE-A3 在检出资源仓的环境下会如实报红）。
  '77': '城市视频-Hangzhou 封面（YouTube qR5TK4SjRdg）',
  '78': '城市视频-Chengdu 封面（YouTube 2yk636WLnd0）',
  '79': '城市视频-Xi’an 封面（YouTube nztG5dYjElA）',
  '80': '城市视频-Guangzhou 封面（YouTube NgjMvYwfxs4）',
  '81': '城市视频-Chongqing 封面（YouTube watliNVeMvM）',
  // DEV-129113：城市视频模块追加 2 张卡，封面图按同一规则序号顺延 82~83。
  // 与 77~81 的一致性已实测核对：线上 cjBusinessTravel77.jpg 与 YouTube hqdefault.jpg 原图
  // md5 逐字节相同，故本批同取 hqdefault.jpg 原图（480x360 baseline JPEG，26~30KB）。
  // **实体待业务方上传资源仓/OSS**，未上传前这两张会裂图（CASE-A2b/CASE-A3 会如实报红）。
  // 编号跟着 videoId 走（82/83 各是该视频自己的缩略图），不跟着城市名走 —— 城市名与视频的
  // 对应关系曾在 2026-09-15 当日改判过一次，原委见 constants.js 的 CITY_VIDEOS 注释；
  // 那次改判**不需要动这两行的编号**，只是下面括号外的城市名随之对调。
  '82': '城市视频-Beijing 封面（YouTube XkBV9o-zNJ8）',
  '83': '城市视频-Shenzhen 封面（YouTube wFNMLhzsWDk）',
};

/** 全部文件名（顺序即编号顺序），供单测校验实体文件是否齐备。 */
var FILES = Object.keys(USAGE).map(function (n) { return 'cjBusinessTravel' + n + '.jpg'; });

/**
 * 生成本页图片取址器。
 * @param {string} [cdnHost] CDN 域名（本地为空串 → 同源路径）
 * @returns {Function} img(name) → {imageName, src}
 */
function createImg(cdnHost) {
  var base = (cdnHost || '') + DIR;
  return function img(name) {
    return { imageName: name, src: base + name };
  };
}

/**
 * 仅取 URL（CSS 背景变量等无需 imageName 的场景）。
 * @param {string} [cdnHost] CDN 域名
 * @param {string} name 文件名
 */
function url(cdnHost, name) {
  return (cdnHost || '') + DIR + name;
}

module.exports = { DIR: DIR, FILES: FILES, USAGE: USAGE, createImg: createImg, url: url };
